import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetReviewerPerformanceHeatmapV1Query } from './get-reviewer-performance-heatmap-v1-request';
import type { IGetReviewerPerformanceHeatmapV1Response } from './get-reviewer-performance-heatmap-v1-response';
import { getReviewerPerformanceHeatmapV1ResponseSchema } from './get-reviewer-performance-heatmap-v1-response';

export async function getReviewerPerformanceHeatmapV1Api(
  query: IGetReviewerPerformanceHeatmapV1Query,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetReviewerPerformanceHeatmapV1Response>> {
  const params = new URLSearchParams();
  params.set('userId', query.userId);
  if (query.days != null) {
    params.set('days', String(query.days));
  }
  return getRequest<IGetReviewerPerformanceHeatmapV1Response>({
    path: `/sys/reviewer-performance/v1/heatmap?${params.toString()}`,
    schema: getReviewerPerformanceHeatmapV1ResponseSchema,
    options,
  });
}
